/* Calls to the API that need the server (sign-in, chat, imports). Same origin, cookie session. */

export class ApiError extends Error {
  constructor(
    readonly status: number,
    readonly code: string,
    message?: string,
  ) {
    super(message ?? code)
  }
}

export async function api<T>(
  path: string,
  init: { method?: string; body?: unknown; signal?: AbortSignal } = {},
): Promise<T> {
  let res: Response
  try {
    res = await fetch(path, {
      method: init.method ?? (init.body === undefined ? 'GET' : 'POST'),
      credentials: 'same-origin',
      headers:
        init.body === undefined
          ? { 'x-cobrito': '1' }
          : { 'content-type': 'application/json', 'x-cobrito': '1' },
      body: init.body === undefined ? undefined : JSON.stringify(init.body),
      signal: init.signal,
    })
  } catch (error) {
    if ((error as Error).name === 'AbortError') throw error
    throw new ApiError(0, 'offline', 'Sin conexión')
  }
  const data = (await res.json().catch(() => ({}))) as { error?: string; message?: string }
  if (!res.ok) throw new ApiError(res.status, data.error ?? 'error', data.message)
  return data as T
}

export async function upload<T>(
  path: string,
  body: Blob | FormData,
  signal?: AbortSignal,
): Promise<T> {
  const res = await fetch(path, {
    method: 'POST',
    credentials: 'same-origin',
    headers: { 'x-cobrito': '1' },
    body,
    signal,
  })
  const data = (await res.json().catch(() => ({}))) as { error?: string; message?: string }
  if (!res.ok) throw new ApiError(res.status, data.error ?? 'error', data.message)
  return data as T
}

export type Me = {
  user: { id: string; email: string; name: string | null }
  workspace_id: string
  features: { ai: boolean; push: boolean }
  vapid_public_key: string | null
}
